export const toggle = <T>(arr: T[], el: T) => (arr.includes(el) ? arr.filter(_el => _el !== el) : [...arr, el])
